import React, { useEffect, useState } from "react";
import Login from "./hr/Login.jsx";
import HRApp from "./hr/HRApp.jsx";
import { apiMe } from "./hr/api.js";

function App() {
  const [authState, setAuthState] = useState({ checking: true, user: null });

  useEffect(() => {
    let mounted = true;
    apiMe()
      .then((u) => {
        if (mounted) setAuthState({ checking: false, user: u });
      })
      .catch((e) => {
        // 401 / network — treat as not authenticated
        console.debug("Initial auth check failed:", e?.response?.status || e?.message);
        if (mounted) setAuthState({ checking: false, user: null });
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (authState.checking) {
    return (
      <div className="hh-fullscreen-loader" data-testid="auth-loading">
        <div className="hh-spinner"></div>
        <div>Loading…</div>
      </div>
    );
  }

  if (!authState.user) {
    return <Login onLogin={(u) => setAuthState({ checking: false, user: u })} />;
  }

  return (
    <HRApp
      user={authState.user}
      onLogout={() => setAuthState({ checking: false, user: null })}
    />
  );
}

export default App;
